import { render, staticRenderFns } from "./ClearAllocations.vue?vue&type=template&id=6f29c46c"
import script from "./ClearAllocations.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearAllocations.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports